export const USER_INFO = "user.info";
export const USER_TOKEN_BASE = "user.token.base";
export const USER_TOKEN_SECURE = "user.token.secure";
export const USER_ACCOUNT_ACCESS = "user.account.access";
export const USER_SELECTED_ACCOUNT = "user.selected.account";